import { Plus } from "lucide-react";
import React from "react";
import './../Groups/groups.css'
import { useNavigate } from "react-router-dom";

const NewFeaturedCourse = ({ toggleFeaturedCourseModal }) => {
  const navigate = useNavigate()
  return (
    <div className="card card-blank" onClick={toggleFeaturedCourseModal}>
      <div className="card-content">
        <Plus style={{ color: '#d1d5db' }} />
        <div style={{ color: '#d1d5db' }}>Add a new Featured Course</div>
      </div>
    </div>
  );
};

export default NewFeaturedCourse;
